// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"_1MVwjAUsaMY5rTj1JiPLZZ","emptyResults":"_2NaRINzEquImGgxXgHr3PV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsList/SongsList.scss
// module id = 1317
// module chunks = 1